var React = require('react');

function IosFeatures (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.3306 22.6173C18.103 23.7783 16.7626 23.595 15.4723 23.0451C14.1068 22.4829 12.8541 22.4585 11.4135 23.0451C9.60958 23.8027 8.65752 23.5828 7.58019 22.6173C1.46694 16.4703 2.3689 7.10929 9.30893 6.76711C11.0001 6.85266 12.1776 7.67144 13.1673 7.74477C14.6455 7.45147 16.0611 6.60824 17.6395 6.71823C19.5311 6.86488 20.9592 7.59812 21.8987 8.91795C17.9902 11.2032 18.9172 16.2259 22.5 17.6313C21.786 19.4644 20.8589 21.2853 19.3181 22.6296L19.3306 22.6173ZM13.042 6.69379C12.8541 3.96858 15.1215 1.71997 17.7272 1.5C18.0905 4.65294 14.7958 6.99931 13.042 6.69379Z","fill":"black"}));
}

IosFeatures.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = IosFeatures;

IosFeatures.default = IosFeatures;
